import { type ReactNode } from "react";

import { cn } from "../../utils/cn.util";
import { Badge } from "../badge";
import type { SvgIcon } from "../icons/type";
import { useLayoutContext } from "./context";

export interface SidebarItemLabelProps {
  Icon?: SvgIcon;
  name: string;
  number?: ReactNode;
  isActive?: boolean;
}

const SidebarItemLabel = ({ Icon, name, number, isActive }: SidebarItemLabelProps) => {
  const { openSidebar } = useLayoutContext();

  return (
    <div className="flex items-center gap-2">
      {Icon ? (
        <Icon
          className={cn(
            "size-4 shrink-0 text-neutral-50 transition-all group-hover/item:text-primary-40",
            isActive && "text-primary-40",
            !openSidebar && "size-4"
          )}
        />
      ) : null}

      <span className={cn("text-sm font-bold whitespace-nowrap transition-all", !openSidebar && "opacity-0")}>
        {name}
      </span>
      {number !== undefined && typeof number === "number" ? (
        <Badge.Root size={"sm"} variant={"light-primary"} shape={"rounded"}>
          <Badge.Label>{number}</Badge.Label>
        </Badge.Root>
      ) : (
        <>{number}</>
      )}
    </div>
  );
};

export default SidebarItemLabel;
